<template>
    <div class="momazon-header-container">
        <div class="momazon-logo-container">
            <a href="/" class="momazon-logo-link">
                DynamicDeals
            </a>
        </div>
    </div>
</template>

<script>
    import settings from '@/settings'
    export default {
        data() {
            return {
                
            }
        },
        computed: {
            settings: function () {
                return settings;
            }
        },
        methods: {
            
        }
    }
</script>